import { createContext } from "react";
import { DefaultContext } from "constants/context";

const PaginationTableContext = createContext(DefaultContext);

export default PaginationTableContext;
